import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { LongArrowRightRegularGlyph, CaretDownSolidGlyph } from '@acast-tech/decibel-glyphs';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";

const NavigationActionGlyph = (_ref) => {
  let {
    action
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["action"]);

  switch (action) {
    case 'dropdown':
      return /*#__PURE__*/_jsx(Icon, Object.assign({
        glyph: CaretDownSolidGlyph
      }, restProps));

    case 'follow':
      return /*#__PURE__*/_jsx(Icon, Object.assign({
        glyph: LongArrowRightRegularGlyph
      }, restProps));

    default:
      return null;
  }
};

NavigationActionGlyph.propTypes = {
  action: T.oneOf(['dropdown', 'follow']).isRequired
};
export { NavigationActionGlyph };